import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=dae72da2&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=dae72da2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae72da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dae72da2')) {
      api.createRecord('dae72da2', component.options)
    } else {
      api.reload('dae72da2', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=dae72da2&scoped=true", function () {
      api.rerender('dae72da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recharge/Detail.vue"
export default component.exports